import React from 'react';
const FloatButtonGroupContext = React.createContext(null);
export const { Provider: FloatButtonGroupProvider } = FloatButtonGroupContext;
export default FloatButtonGroupContext;
